var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreelancer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    opacity: 0,
    points: "2 2 22 2 22 22 2 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.975,6.80833333 L13.7916667,5.21666667 L22,5.21666667 L14.975,6.80833333 Z M6.55,19.8833333 L10.2916667,16.1916667 L8.04166667,13.7583333 L6.55,19.8833333 Z M14.3666667,6.90833333 L13.1583333,5.24166667 L11.1666667,6.74166667 L14.375,6.90833333 L14.3666667,6.90833333 Z M9.61666667,6.66666667 L5.23333333,5 L5.9,6.49166667 L9.60833333,6.66666667 L9.61666667,6.66666667 Z M2,6.825 L7.55833333,12.4333333 L10.2833333,7.25 L2,6.825 Z M14.5,7.45833333 L10.875,7.275 L7.94166667,12.8583333 L10.6666667,15.8 L13.5833333,12.9166667 L14.5,7.45833333 Z",
    fill: "#139FF0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelancer);
export default __webpack_public_path__ + "static/media/freelancer.4bc7c336c0663d6a7d998d8e82316ffa.svg";
export { ForwardRef as ReactComponent };